module.exports = __webpack_public_path__ + "img/nocandapplication.6a61674f.svg";